module.exports = __webpack_public_path__ + "img/46_35.1ab299c5.png";